export default "__VITE_PUBLIC_ASSET__95fbfc14__"